import {Column, HeaderProps} from 'react-table'
import {ISingleBroadcast} from '../core/_model'
import SelectionHeader from '../../../utils/components/Table/SelectionHeader'
import {ListViewContext} from '../../../utils/contextProvider/ListViewProvider'
import {SelectionCell} from '../../../utils/components/Table/SelectionCell'
import {PropsWithChildren, ReactNode} from 'react'
import {CustomHeader} from '../../../utils/components/Table/CustomHeader'
import {formatDate} from '../../../utils/helperFunction/_helper'
import BroadcastHistoryAction from '../BroadcastHistoryAction'

const createBroadcastHistoryColumn = (
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>,
  setSingleBroadcast: React.Dispatch<React.SetStateAction<ISingleBroadcast | undefined>>
): ReadonlyArray<Column<ISingleBroadcast>> => [
  {
    Header: (props) => <SelectionHeader tableProps={props as any} context={ListViewContext} />,
    id: 'selection',
    Cell: ({...props}) => (
      <SelectionCell id={props.data[props.row.index].id} context={ListViewContext} />
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ISingleBroadcast>>) => (
      <CustomHeader tableProps={props} title='Date' className='min-w-100px' />
    ),
    id: 'dateTime',
    Cell: ({...props}) => <>{formatDate(props.data[props.row.index].dateTime)}</>,
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ISingleBroadcast>>) => (
      <CustomHeader tableProps={props} title='User' className='min-w-100px' />
    ),
    id: 'user',
    accessor: 'user',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ISingleBroadcast>>) => (
      <CustomHeader tableProps={props} title='SMS Part' className='min-w-100px' />
    ),
    id: 'smsPart',
    accessor: 'smsPart',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ISingleBroadcast>>) => (
      <CustomHeader tableProps={props} title='SMS Type' className='min-w-100px' />
    ),
    id: 'smsType',
    accessor: 'smsType',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ISingleBroadcast>>) => (
      <CustomHeader tableProps={props} title='Sender' className='min-w-100px' />
    ),
    id: 'sender',
    accessor: 'sender',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ISingleBroadcast>>) => (
      <CustomHeader tableProps={props} title='Count' className='min-w-100px' />
    ),
    id: 'count',
    accessor: 'count',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ISingleBroadcast>>) => (
      <CustomHeader tableProps={props} title='SMS Text' className='min-w-100px' />
    ),
    id: 'smsText',
    accessor: 'smsText',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ISingleBroadcast>>) => (
      <CustomHeader tableProps={props} title='Action' className='min-w-100px' />
    ),
    id: 'action',
    Cell: ({...props}) => (
      <BroadcastHistoryAction
        broadcast={props.data[props.row.index]}
        setShowModal={setShowModal}
        setSingleBroadcast={setSingleBroadcast}
      />
    ),
  },
]

export default createBroadcastHistoryColumn
